var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7501 0.499725C6.00536 0.499725 0.500122 6.00496 0.500122 12.7497C0.500122 19.4945 6.00536 24.9997 12.7501 24.9997C15.8091 24.9997 18.6039 23.8588 20.755 21.9919L21.5001 22.737V24.9997L32.0001 35.4997L35.5001 31.9997L25.0001 21.4997H22.7374L21.9923 20.7546C23.8592 18.6035 25.0001 15.8087 25.0001 12.7497C25.0001 6.00496 19.4949 0.499725 12.7501 0.499725ZM12.7501 3.99972C17.6033 3.99972 21.5001 7.8965 21.5001 12.7497C21.5001 17.6029 17.6033 21.4997 12.7501 21.4997C7.8969 21.4997 4.00012 17.6029 4.00012 12.7497C4.00012 7.8965 7.8969 3.99972 12.7501 3.99972Z",
    fill: "#BD1823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.690c7c32648546b8d85b3c6b941e9caa.svg";
export { ForwardRef as ReactComponent };